// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1seu6","title":"ClientCherryInfo_title__2I9He","itemText":"ClientCherryInfo_itemText__1fgkH"};